var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwentyPercent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1723_976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1723_976)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1723_976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6C18.5029 6 18.9886 6.18857 19.36 6.53143C19.7314 6.87429 19.9543 7.34286 19.9943 7.84571V7.99429V8.99429C20.4971 8.99429 20.9829 9.18286 21.3543 9.52571C21.7257 9.86857 21.9486 10.3371 21.9886 10.84V10.9886V12.9886C21.9886 13.4914 21.8 13.9771 21.4571 14.3486C21.1143 14.72 20.6457 14.9429 20.1429 14.9829H19.9943V15.9886C19.9943 16.4914 19.8057 16.9771 19.4629 17.3486C19.12 17.72 18.6514 17.9429 18.1486 17.9829H18H4C3.49714 17.9829 3.01143 17.7943 2.64 17.4514C2.26857 17.1086 2.04571 16.64 2.00571 16.1371V15.9886L2 8C2 7.49714 2.18857 7.01143 2.53143 6.64C2.87429 6.26857 3.34857 6.04571 3.85143 6H4H18ZM18 8H4V16H18V8ZM6.54286 9C6.80571 9 7.06286 9.10286 7.25143 9.29143C7.44 9.48 7.54286 9.73143 7.54286 10V14C7.54286 14.2629 7.43429 14.52 7.25143 14.7086C7.06857 14.8971 6.81143 15 6.54286 15C6.27429 15 6.02286 14.8971 5.83429 14.7086C5.64571 14.52 5.54286 14.2686 5.54286 14V10C5.54286 9.73714 5.65143 9.48 5.83429 9.29143C6.02286 9.10286 6.27429 9 6.54286 9Z",
    fill: "#EA4444"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1723_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12,
    fill: "white",
    transform: "translate(2 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwentyPercent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twentyPercent.3b41b83b.svg";
export { ForwardRef as ReactComponent };